export const SET_UNIQUE_ID = 'SET_UNIQUE_ID'
export const UNSET_UNIQUE_ID = 'UNSET_UNIQUE_ID'
export const UNSET_UNIQUE_IDS = 'UNSET_UNIQUE_IDS'
